// Search API client built on Axios
// Exposes simple functions to query backend Whoosh endpoints

export const searchApi = {
  /**
   * Perform full-text search
   * @param {Object} params
   * @param {string} params.sq - search query
   * @param {number} [params.page=1] - page number (1-based)
   * @param {number} [params.limit] - optional per-page limit (server may ignore)
   * @param {Object} [params.filters] - optional filters (reserved)
   * @returns {Promise<object>} search response JSON
   */
  async search({ sq, page = 1, limit, filters, cat, dateFrom, dateTo } = {}) {
    if (!sq || typeof sq !== 'string' || sq.trim() === '') {
      throw new Error('Empty search query');
    }
    const params = { sq: sq.trim(), page };
    if (typeof limit === 'number') params.limit = limit;
    // Support direct filter parameters from URL
    if (cat && typeof cat === 'string') params.cat = cat;
    if (dateFrom && typeof dateFrom === 'string') params.dateFrom = dateFrom;
    if (dateTo && typeof dateTo === 'string') params.dateTo = dateTo;
    // Legacy filters object support (reserved)
    if (filters && typeof filters === 'object') params.filters = JSON.stringify(filters);

    const res = await window.axios.get('/api/search', { params });
    return res.data;
  },

  /**
   * Get autocomplete suggestions
   * @param {Object} params
   * @param {string} params.sq - partial query
   * @param {number} [params.limit=5] - max suggestions
   * @returns {Promise<object>} suggestions response
   */
  async suggest({ sq, limit = 5 } = {}) {
    if (!sq || typeof sq !== 'string') return { suggestions: [] };
    const res = await window.axios.get('/api/search/autocomplete', { params: { sq, limit } });
    return res.data;
  },
};

// Expose globally for non-module callers if needed
if (typeof window !== 'undefined') {
  window.searchApi = searchApi;
}


